export class NodeSolo {
    editable: boolean = false;
    expandable: boolean = false;
    expanded: boolean = false;
    editing: boolean = false;
    active: boolean = false;
    moved: boolean = false;
    canDrag: boolean = false;
    canDrop: boolean = false;
}
